import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

// Function to send OTP email
export const sendOTPEmail = async (email, loginOTP, withdrawalOTP) => {
  try {
    const templateParams = {
      to_email: email,
      login_otp: loginOTP,
      withdrawal_otp: withdrawalOTP,
      from_name: 'QuickwealthInvest Support',
      to_name: email.split('@')[0], // Use the part before @ as name
    };

    const response = await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error('Error sending email:', error);
    return { success: false, error: error.message };
  }
}; 